<!-- Desktop TOWN-HUAL Header -->
<div class="t-icon">
    <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
</div>
<div class="header-wrapper d-none d-md-block normal-header pb-md-2 pb-lg-3" [class.show]="!isSticky">
    <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>
    <div class="container-fluid ps-lg-5">
        <div class="row align-items-end">
            <div class="col-md-12 col-lg-3 logo-col text-center text-lg-start logo-tabs ps-lg-4 ps-xl-5 ">
                <app-header-logo *ngIf="showLogo"></app-header-logo>
            </div>
            <div class="col-12 col-md-9 col-lg-7 mid-col">
                <div class="row">
                    <div class="col-12 mb-lg-2">
                        <div class="d-flex align-items-center justify-content-between justify-content-lg-start">
                            <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                            <app-header-contact-us-section></app-header-contact-us-section>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center justify-content-start">
                    <div class="col-12 col-md-6 col-xl-9 cust-left pe-0" [ngClass]="{ 'l-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-6 col-xl-3  cust-right" [ngClass]="{ 'r-width': isWishlist}">
                        <div class="d-flex justify-content-between justify-content-lg-start wrap-app align-items-center p-0">
                            <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3 col-lg-2 pe-0 end-col" *ngIf="!chTheme8" >
                <div class="grey-box-hual">
                <app-header-my-garage-section></app-header-my-garage-section>
                </div>
            </div>
        <div *ngIf="chTheme8">
            <app-header-third-row></app-header-third-row>
       </div>     
        </div>
    </div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block" [class.show]="isSticky">
    <div class="sticky-menu menu-icon" [ngClass]="{'sticky-active': isSticky}">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-2">
        <div class="row px-3 align-items-center justify-content-between pe-0">
            <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs  d-flex justify-content-center justify-content-lg-end"
               >
                <img [routerLink]="'/'" (click)="onButtonClick()" *ngIf="showLogo"
                    [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" alt="Logo"
                    class="img-fluid d-none d-md-block desktop-img cursor-pointer ps-lg-5 " fetchpriority="high" width="250"
                    height="70"/>
            </div>
              <div class="col-12 col-md-9 col-lg-7 mid-col">
                <!-- <div class="row">
                    <div class="col-12 mb-lg-2">
                        <div class="d-flex align-items-center justify-content-between justify-content-lg-start">
                            <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                            <app-header-contact-us-section></app-header-contact-us-section>
                        </div>
                    </div>
                </div> -->

                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-md-6 col-xl-9 cust-left pe-0" [ngClass]="{ 'sticky-l-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-6 col-xl-3  cust-right" [ngClass]="{ 'sticky-r-width': isWishlist}">
                        <div class="d-flex justify-content-between justify-content-lg-start wrap-app align-items-center p-0">
                            <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3 col-lg-2 end-col" *ngIf="!chTheme8">
                <div class="grey-box-hual">
                <app-header-my-garage-section></app-header-my-garage-section>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container-fluid d-md-none">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>